import RootLayout from "@/app/layout";
import data from '../../data/angebot/data.json';
import { DetailAngebotSection } from "@/app/components/Sections/DetailAngebotSection";
import Head from "next/head";

export const metadata = {
    title: 'Hebamme Lea Stiffler | Schwangerschaftsbetreuung',
    description: 'Professionelle Schwangerschaftsbetreuung. Individuelle Beratung und Unterstützung während der Schwangerschaft durch erfahrene Hebamme. Alles für eine gesunde Schwangerschaft und Vorbereitung auf die Geburt.',
    keywords: 'Schwangerschaftsbetreuung, Schwangerschaft Beratung, Hebamme Chur, gesunde Schwangerschaft, Geburtsvorbereitung, Schwangerschaftskontrollen',
    canonicalUrl: 'https://hebamme-leastiffler.ch/schwangerschaftsbetreuung'
}


export async function getStaticProps() {
    return { props: { data } }
}

export default function Schwangerschaftsbetreuung({ data }) {
    const schwangerschaftsbetreuungData = data.Schwangerschaftsbetreuung;

    return (
        <RootLayout>
            <Head>
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <link rel="canonical" href={metadata.canonicalUrl} />
            </Head>
            <DetailAngebotSection data={schwangerschaftsbetreuungData} />
        </RootLayout>
    )
}